import { Button, Col, FormGroup, Input, Label, Row, Select } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useRedis } from '@/hooks/useRedis'
import { useAppSelector } from '@/redux/hooks'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

interface BlogDetailItem {
  cmpnyCd: string
  cstId: string
  nttSn: number
  nttSj: string
  nttCn: string
  readngCnt: number
  answerCnt: number
  regId: string
  regDate: string
  updId: string
  updDate: string
  useYn: string
  delYn: string
  adminDelYn: string
  nickName: string
}

interface BlogCommentItem {
  cmpnyCd: string
  nttSn: number
  commentSn: number
  commentCn: string
  cstId: string
  accessIp: string
  regId: string
  regDate: string
  updId: string
  updDate: string
  nickName: string
  withDrawYn: string
  adminDelYn: string
  useYn: string
  delYn: string
}

type CommentUpdate = {
  commentSn: number
  adminDelYn: 'Y' | 'N'
  useYn: 'Y' | 'N'
  delYn: 'Y' | 'N'
  option?: 'ADD' | 'DEL'
}

const DetailBlogMgmt: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAppSelector((state) => state.auth)
  const { showAlert, showConfirm } = useDialog()
  const { getComCodes, getComCodeValue } = useRedis()
  const [requestData] = useState({
    nttSn: location.state?.nttSn || '',
  })

  const [blog, setBlog] = useState<BlogDetailItem>({
    cmpnyCd: '',
    nttSn: 0,
    nttSj: '',
    nttCn: '',
    readngCnt: 0,
    answerCnt: 0,
    cstId: '',
    regId: '',
    regDate: '',
    updId: '',
    updDate: '',
    adminDelYn: '',
    useYn: '',
    delYn: '',
    nickName: '',
  })
  const [comments, setComments] = useState<BlogCommentItem[]>([])
  const [isVisible, setIsVisible] = useState<boolean>(true)

  useEffect(() => {
    getBlogDetail()
    getCommentList()
  }, [])

  const formatDateString = (dateString?: string): string => {
    if (!dateString || dateString.length !== 8) return ''

    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6)
    const day = dateString.substring(6, 8)

    return `${year}.${month}.${day}`
  }

  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState)
  }

  const getBlogDetail = async () => {
    try {
      const response = await axios.get('/blogMgmt/detail', {
        params: { nttSn: requestData.nttSn },
      })
      const common = response.data.common
      if (common.resultCode === 'BLOGS0202') {
        const blogData = response.data.data.blogDetail
        setBlog(blogData)
      } else {
        const closeFunc = () => {
          navigate('/blogMgmt', {
            state: {
              srchData: location.state?.srchData,
              page: location.state?.page || 1,
              perPage: location.state?.perPage || 1,
            },
          })
        }
        showAlert({
          title: common.resultCode,
          message: common.resultMsg,
          onClose: closeFunc,
        })
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const getCommentList = async () => {
    try {
      const response = await axios.get('/blogMgmt/comment/list', {
        params: { nttSn: requestData.nttSn },
      })
      const common = response.data.common
      if (common.resultCode == 'BLOGS0204') {
        const data = response.data.data
        const commentList = data.commentList
        setComments(data.commentList)
      } else {
        const closeFunc = () => {
          navigate('/blogMgmt', {
            state: {
              srchData: location.state?.srchData,
              page: location.state?.page || 1,
              perPage: location.state?.perPage || 1,
            },
          })
        }
        showAlert({
          title: common.resultCode,
          message: common.resultMsg,
          onClose: closeFunc,
        })
      }
    } catch (error) {
      console.error('Error fetching terms info:', error)
    }
  }

  const updateBlog = async () => {
    try {
      const response = await axios.post('/blogMgmt/update', blog)
      const common = response.data.common
      if (common.resultCode == 'BLOGU0200') {
        showAlert({
          type: 'success',
          message: '수정되었어요.',
          title: '성공',
          onClose() {
            navigate('/blogMgmt', {
              state: {
                srchData: location.state?.srchData,
                page: location.state?.page || 1,
                perPage: location.state?.perPage || 1,
              },
            })
          },
        })
      } else {
        showAlert({
          type: 'error',
          message: common.resultMsg || '업데이트 실패',
          title: common.resultCode,
        })
      }
    } catch (error) {
      console.error('Error fetching terms reg:', error)
    }
  }

  const updateComment = async (params: CommentUpdate) => {
    try {
      const response = await axios.post('/blogMgmt/comment/update', {
        ...params,
      })
      const common = response.data.common
      if (common.resultCode == 'BLOGU0202') {
        showAlert({
          type: 'success',
          message: '수정이 완료되었어요.',
        })
        getCommentList()
      } else {
        showAlert({
          type: 'error',
          message: common.resultMsg,
          title: common.resultCode,
        })
      }
    } catch (error) {
      console.error('Error fetching terms reg:', error)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target
    setBlog((prevState) => {
      return {
        ...prevState,
        [name]: value,
        ['updId']: user.userId,
      }
    })
  }

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ fontSize: '20px' }}>목소리게시판 관리</p>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              color="neverbe"
              onClick={() => {
                navigate('/blogMgmt', {
                  state: {
                    srchData: location.state?.srchData,
                    page: location.state?.page || 1,
                    perPage: location.state?.perPage || 1,
                  },
                })
              }}
            >
              목록
            </Button>
            <Button
              onClick={() => {
                updateBlog()
              }}
              color="neverbe"
            >
              저장
            </Button>
          </div>
        </div>
      </div>
      <div>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSn">
                번호
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSn"
                name="nttSn"
                type="text"
                maxLength={10}
                value={blog.nttSn}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                작성자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regId"
                name="regId"
                type="text"
                placeholder=""
                maxLength={3}
                value={blog.nickName + ` (${blog?.regId})`}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                작성일
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regDate"
                name="regDate"
                type="text"
                placeholder=""
                maxLength={3}
                value={commonUtils.formatDate(blog.regDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttSj">
                제목
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="nttSj"
                name="nttSj"
                type="text"
                maxLength={250}
                value={blog.nttSj}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="nttCn">
                내용
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <div
                id="nttCn"
                style={{
                  height: '400px',
                  overflowY: 'auto',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  backgroundColor: 'rgb(245, 246, 250)',
                }}
                dangerouslySetInnerHTML={{ __html: blog?.nttCn || '' }}
              />
            </FormGroup>
          </Col>
        </Row>
        {comments.length > 0 && (
          <>
            <div className="comment-toggle-header" onClick={toggleVisibility}>
              <span>
                댓글관리
                <span className="comment-note">
                  &nbsp;*사용자가 삭제한 댓글은 보이지 않아요.
                </span>
              </span>
              <span>{isVisible ? '▲' : '▼'}</span>
            </div>
            {isVisible && (
              <div className="comment-list">
                {comments.map((comment, index) => {
                  const isAdminDeleted = comment.adminDelYn === 'Y'
                  const isUserDeleted =
                    !isAdminDeleted &&
                    comment.useYn === 'N' &&
                    comment.delYn === 'Y'
                  return (
                    <div
                      className={`comment-card ${
                        isAdminDeleted
                          ? 'adminDeleted'
                          : isUserDeleted
                            ? 'userDeleted'
                            : ''
                      }`}
                      key={index}
                    >
                      <div className="comment-header">
                        <span className="comment-author">
                          {comment.nickName + ` (${comment?.regId})`}
                        </span>
                        <span className="comment-date">{comment.regDate}</span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <div className="comment-content">
                          {comment.commentCn}
                        </div>
                        {isAdminDeleted ? (
                          <button
                            className="comment-restore-btn"
                            onClick={() =>
                              updateComment({
                                commentSn: comment.commentSn,
                                adminDelYn: 'N',
                                useYn: 'Y',
                                delYn: 'N',
                                option: 'ADD',
                              })
                            }
                          >
                            복원
                          </button>
                        ) : !isUserDeleted ? (
                          <button
                            className="comment-delete-btn"
                            onClick={() =>
                              updateComment({
                                commentSn: comment.commentSn,
                                adminDelYn: 'Y',
                                useYn: 'Y',
                                delYn: 'N',
                                option: 'DEL',
                              })
                            }
                          >
                            삭제
                          </button>
                        ) : null}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </>
        )}
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                어드민 삭제 여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="adminDelYn"
                name="adminDelYn"
                value={blog.adminDelYn}
                onChange={handleInputChange}
              >
                {getComCodes('ADMIN_DEL_YN').map((item) => (
                  <option key={'adminDelYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                사용여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="useYn"
                name="useYn"
                value={blog.useYn}
                onChange={handleInputChange}
              >
                {getComCodes('USE_YN').map((item) => (
                  <option key={'useYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="useYn">
                삭제여부
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Select
                id="delYn"
                name="delYn"
                value={blog.delYn}
                onChange={handleInputChange}
              >
                {getComCodes('DEL_YN').map((item) => (
                  <option key={'delYn' + item.code} value={item.code}>
                    {item.codeNm}
                  </option>
                ))}
              </Select>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regId">
                등록자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regId"
                name="regId"
                type="text"
                placeholder=""
                maxLength={100}
                value={blog.regId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="regDate">
                등록일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="regDate"
                name="regDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(blog.regDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updId">
                수정자
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="updId"
                name="updId"
                type="text"
                placeholder=""
                maxLength={100}
                value={blog.updId}
                disabled={true}
              />
            </FormGroup>
          </Col>
          <Col col>
            <FormGroup mb="20px">
              <Label display="block" mb="5px" htmlFor="updDate">
                수정일시
              </Label>
              <div style={{ marginBottom: '5px' }} />
              <Input
                id="updDate"
                name="updDate"
                type="text"
                placeholder=""
                maxLength={100}
                value={commonUtils.formatDate(blog.updDate, true)}
                disabled={true}
              />
            </FormGroup>
          </Col>
        </Row>
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
          }}
        >
          <div style={{ display: 'flex', gap: '5px' }}>
            <Button
              color="neverbe"
              onClick={() => {
                navigate('/blogMgmt', {
                  state: {
                    srchData: location.state?.srchData,
                    page: location.state?.page || 1,
                    perPage: location.state?.perPage || 1,
                  },
                })
              }}
            >
              목록
            </Button>
            <Button
              onClick={() => {
                updateBlog()
              }}
              color="neverbe"
            >
              저장
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
export default DetailBlogMgmt
